"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HyphenWithdrawWorkflowComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var HyphenWithdrawWorkflowComponent = exports.HyphenWithdrawWorkflowComponent = function HyphenWithdrawWorkflowComponent(_ref) {
  var productId = _ref.productId,
    templateType = _ref.templateType,
    _ref$template = _ref.template,
    template = _ref$template === void 0 ? {} : _ref$template,
    getBankInfoForm = _ref.getBankInfoForm;
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return !Object.keys(template).includes('BankAccountNumber') ? /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    onClick: function onClick() {
      return getBankInfoForm(productId, templateType);
    },
    styleName: "additive"
  }, t("Edit banking information")) : null;
};
HyphenWithdrawWorkflowComponent.propTypes = {
  productId: _propTypes["default"].number.isRequired,
  templateType: _propTypes["default"].string.isRequired,
  template: _propTypes["default"].object.isRequired,
  getBankInfoForm: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = HyphenWithdrawWorkflowComponent;